


































































































import _ from 'lodash';
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import CreateUser from './create-user.vue'
import EditUser from './edit-user.vue'
import AdminColumns from './admin-user-columns'
class  PageUserRequest extends PageRequest{
    keyword:string;
    isActive:boolean=null;//nullable
    clientCode:string="";
}

@Component({
    components:{CreateUser,EditUser}
})
export default class Users extends AbpBase{
    edit(){
        this.editModalShow=true;
    }
    //filters
    pagerequest:PageUserRequest=new PageUserRequest();

    createModalShow:boolean=false;
    editModalShow:boolean=false;
    get client() {
      return this.$store.state.session.client;
    }
    isClient() {
      return this.$store.state.session.client!=null;
    }
    isTenant() {
      return this.$store.state.session.tenant != null;
    }
    get tenant() {
      return this.$store.state.session.tenant;
    }
    get clientId() {
      return this.isClient()? this.client.code:null;
    }
     get tenantId() {
      return this.isTenant()? this.tenant.id:null;
    }
    get list(){
        return this.$store.state.user.list;
    }
    get loading(){
        return this.$store.state.user.loading;
    }
    create(){
        this.createModalShow=true;
    }
    isActiveChange(val:string){
        if(val==='Actived'){
            this.pagerequest.isActive=true;
        }else if(val==='NoActive'){
            this.pagerequest.isActive=false;
        }else{
            this.pagerequest.isActive=null;
        }
    }
    pageChange(page:number){
        this.$store.commit('user/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('user/setPageSize',pagesize);
        this.getpage();
    }
    @Watch("client")
    async getpage(){
      
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        if(this.isClient())
        {
          this.pagerequest.clientCode = this.client.code;
        }
        //filters
        await this.$store.dispatch({
            type:'user/getAll',
            data:this.pagerequest
        })
    }
    get pageSize(){
        return this.$store.state.user.pageSize;
    }
    get totalCount(){
        return this.$store.state.user.totalCount;
    }
    get currentPage(){
        return this.$store.state.user.currentPage;
    }
     renderColumn()
    {
        if(this.isTenant() || this.isClient())
        {
          return [];
        }
        return AdminColumns;
    }
    columns=[{
        title:this.L('UserName'),
        key:'userName'
    },{
        title:this.L('Name'),
        key:'name'
    },
     ...this.renderColumn(),
   {
        title:this.L('IsActive'),
        render:(h:any,params:any)=>{
           return h('span',params.row.isActive?this.L('Yes'):this.L('No'))
        }
    },{
        title:this.L('CreationTime'),
        key:'creationTime',
        render:(h:any,params:any)=>{
            return h('span',Util.toViewDateString(params.row.creationTime))
        }
    },{
        title:this.L('Action'),
        key:'Actions',
        width:200,
        align:'center',
        render:(h:any,params:any)=>{
          if((this.tenantId !== params.row.tenantId || this.clientId!==params.row.clientCode)) {
            return h('div',[])
          }
           var resetAction = h('Button',{
                    props:{
                        type:'primary',
                        size:'small',
                        icon: 'md-repeat'
                    },
                    style:{
                        marginRight:'5px',
                        display: this.hasPermission("Configs.Users.ResetPassword") 
                          ? ""
                          : "none"
                    },
                    on:{
                        click:async ()=>{
                             this.$Modal.confirm({
                                    title:this.L('Tips'),
                                    content:this.L('Confirm.ResetUserPassword'),
                                    okText:this.L('Yes'),
                                    cancelText:this.L('No'),
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'user/resetUserPassword',
                                            data:{
                                              UserId : params.row.id
                                            }
                                        });
                                        this.$Message.success(this.L('Success.ResetUserPassword'));
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                },this.L(''));
          var tooltipResetAction = h('Tooltip', {
                props: {
                  placement: 'top',
                  transfer: true,
                  content: Util.L('ResetPassword')
                }, 
            }, [resetAction]);
          var editAction = h('Button',{
                    props:{
                        type:'primary',
                        size:'small',
                        icon:'ios-hammer'

                    },
                    style:{
                        marginRight:'5px',
                        display: this.hasPermission("Configs.Users.Update") 
                          ? ""
                          : "none"
                    },
                    on:{
                        click:()=>{
                            this.$store.commit('user/edit',params.row);
                            this.edit();
                        }
                    }
                },this.L(''));
            var tooltipEditAction = h('Tooltip', {
                props: {
                  placement: 'top',
                  transfer: true,
                  content: Util.L('Edit')
                }, 
            }, [editAction]);
            var deleteAction = h('Button',{
                    props:{
                        type:'error',
                        size:'small',
                        icon:'md-trash'
                    },
                    style:{
                      marginRight:'5px',
                        display: this.hasPermission("Configs.Users.Delete") 
                          ? ""
                          : "none"
                    },
                    on:{
                        click:async ()=>{
                            this.$Modal.confirm({
                                    title:this.L('Tips'),
                                    content:this.L('DeleteUserConfirm'),
                                    okText:this.L('Yes'),
                                    cancelText:this.L('No'),
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'user/delete',
                                            data:params.row
                                        })
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                },this.L(''));
            var tooltipDeleteAction = h('Tooltip', {
                props: {
                  placement: 'top',
                  transfer: true,
                  content: Util.L('Delete')
                }, 
            }, [deleteAction]);
            var unlockAction = h('Button',{
                    props:{
                        type:'primary',
                        size:'small',
                        icon: 'ios-unlock'
                    },
                    style:{
                        marginRight:'5px',
                        display: this.hasPermission("Configs.Users.Unlock") && params.row.isLockoutEnabled
                          ? ""
                          : "none"
                    },
                    on:{
                        click:async ()=>{
                             this.$Modal.confirm({
                                    title:this.L('Tips'),
                                    content:this.L('Confirm.UnlockUser'),
                                    okText:this.L('Yes'),
                                    cancelText:this.L('No'),
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'user/unlockUser',
                                            data:{
                                              UserId : params.row.id
                                            }
                                        });
                                        this.$Message.success(this.L('Success.UnlockUser'));
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                },this.L(''));
            var tooltipUnlockAction = h('Tooltip', {
                props: {
                  placement: 'top',
                  transfer: true,
                  content: Util.L('Unlock')
                }, 
            }, [unlockAction]);
            return h('div',[tooltipEditAction, tooltipDeleteAction, tooltipResetAction, tooltipUnlockAction])
        }
    }]
    async created(){
        this.getpage();
        await this.$store.dispatch({
            type:'user/getRoles'
        });
        await this.$store.dispatch({
            type:'user/getClients'
        });
    }
}
